import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExpertDataService from "../services/Expert";
import { Loader } from "../components/Loader/Loader";
import { Information } from "../components/ExpertView/Information";
import { transformExpertDetails } from "../Config/Expert";
import { Points } from "../components/ExpertView/Points";
import { AESSInfo } from "../components/ExpertView/AESSInfo";
import { AppInfo } from "../components/ExpertView/AppInfo";

export const ExpertView = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [row, setRow] = useState<any>();
  const { id } = useParams();

  const fetchData = () => {
    setIsLoading(true);
    ExpertDataService.getSingleExpert(String(id))
      .then((res) => {
        const data = res.data;
        setRow(transformExpertDetails(data.data));
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  };

  const handlePdfGenerator = () => {
    ExpertDataService.getExpertPdf(id)
      .then((res: any) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "expert.pdf";
        link.click();
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Experts - App Experts</div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="p-4">
          <div className="row m-0 justify-content-between align-items-center">
            <div className="col-sm-8 p-lg-0">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => navigate(`/experts/edit/${id}`)}
                >
                  Edit
                </button>
              </div>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => navigate(`/calender/${id}`)}
                >
                  Set Calender
                </button>
              </div>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={handlePdfGenerator}
                >
                  Generate Expert PDF
                </button>
              </div>
            </div>
          </div>

          {row ? (
            <div className="main-section">
              <div className="row justify-content-center client-detail-sec">
                <div className="col-sm-8 card p-4">
                  <div className="row">
                    <div className="col-sm-5">
                      <div className="client-pic">
                        <img
                          src={
                            row.photograph_link
                              ? row.photograph_link
                              : "/img/avtar.png"
                          }
                          alt="user-img"
                        />
                      </div>
                      <div className="personal-information text-center pt-3">
                        <h5>{row.full_name ? row.full_name : "No Name"}</h5>
                        <p className="mb-1">
                          {row.personal_email_id
                            ? row.personal_email_id
                            : "No Email"}
                        </p>
                        <p className="mb-1">
                          {row.phone_number
                            ? row.phone_number
                            : "Contact Not Available"}
                        </p>
                      </div>
                    </div>

                    <Information props={row} />
                  </div>
                </div>
              </div>
              <div className="row justify-content-center client-detail-sec mx-0 mt-5">
                <div className="col-sm-12 card px-5 mt-5  p-3">
                  <h2>Pdf data</h2>
                  <div className="row justify-content-between">
                    <Points data={row.experience_points} name={"Experience"} />
                    <Points data={row.education} name={"Education"} />
                    <Points
                      data={row.area_of_expertise}
                      name={"Area of Expertise"}
                    />
                    <h4 className="col-sm-4 mt-5">
                      Total Experience :-{" "}
                      {row.total_experience ? row.total_experience : 0} Years
                    </h4>
                  </div>
                </div>
                <div className="col-sm-12 card px-5 mt-5 p-3">
                  <h2>AESS Data</h2>
                  <div className="row justify-content-between">
                    <AESSInfo {...row} />
                  </div>
                </div>
                <div className="col-sm-12 card px-5 mt-5 p-3">
                  <h2>App Info</h2>
                  <div className="row justify-content-between">
                    <AppInfo {...row} />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      )}
    </div>
  );
};
